export const SET_CONTENT = "SET_CONTENT";
export const SET_CONTENT_ERROR = "SET_CONTENT_ERROR";
export const SET_OFFERED_FREE_TRIAL = "SET_OFFERED_FREE_TRIAL";
export const SET_FIRST_NAME = "SET_FIRST_NAME";
export const SET_INCLUDE_FREE_TRIALS = "SET_INCLUDE_FREE_TRIALS";

export function setContent(data) {
  return {
    type: "SET_CONTENT",
    content: data,
  };
}

export function setContentError() {
  return {
    type: "SET_CONTENT_ERROR",
    errorMessage: "Failed to add content data to store",
  };
}

export function setIncludeFreeTrials(includeFreeTrials) {
  return {
    type: SET_INCLUDE_FREE_TRIALS,
    includeFreeTrials,
  };
}

export function setOfferedFreeTrial(offeredFreeTrial) {
  return {
    type: SET_OFFERED_FREE_TRIAL,
    offeredFreeTrial,
  };
}

export function setFirstName(firstName) {
  return {
    type: SET_FIRST_NAME,
    firstName,
  };
}
